export default "__VITE_ASSET__CYSYCMH8__"